import { z } from 'zod';

// Folha do módulo (sem imports de `mice*`): `mice.ts` e `mice_participants.ts` dependem dela
// sem fechar ciclo.
export const MiceNamedRefSchema = z.object({ id: z.string().min(1), name: z.string() });
export type MiceNamedRef = z.infer<typeof MiceNamedRefSchema>;

export const IataSchema = z.string().regex(/^[A-Z]{3}$/);

export const MiceMoneySchema = z.object({ amount: z.number(), currency: z.string() });
export type MiceMoney = z.infer<typeof MiceMoneySchema>;

export const NumericIdSchema = z.string().regex(/^\d+$/);

/** O corpo das ações do organizador sem outro dado: confirmar as premissas, encerrar e reabrir
 *  as compras, reabrir as premissas, publicar o evento. */
export const SelfServiceActionRequestSchema = z.object({ organizerId: NumericIdSchema });
export type SelfServiceActionRequest = z.infer<typeof SelfServiceActionRequestSchema>;
